import React from "react";
import {Link} from "@material-ui/core";
import {NavLink} from "react-router-dom";


const DontHaveRooms = (props) => {
    const {objectId} = props

    return (
        <div className="main">
            <div className="d-flex align-items-center justify-content-center h-100 w-100">
                <h5 className="px-2 text-center">
                    У Вас пока нет номеров. <Link component={NavLink}
                                                            to={`/lk/${objectId}/rooms/new`}><b>"Добавить номер"</b></Link>
                </h5>
            </div>
        </div>
    )
}

export default DontHaveRooms